import { auth, loginLog, getTerrId, getUserRole, getUserTa, adminLogin, switchRole } from '@/api/user';
import * as py from '@/api/Physicians';
import * as help from '@/api/help';
import { setToken } from '@/utils/auth';
import { setLocalStorage, getLocalStorage, removeAllLocalStorage, resolveEnableAI, isEnableAI, isSalesManagerTerritory, normalizeSalesOverviewContext, clearManagerOverviewPeriodState } from '@/utils/index';
import * as crypto from 'crypto-js';
import * as moment from 'moment';

const SALES_MANAGER_TERRITORY_TYPES = ['DM', 'AM', 'SD'];

function normalizeRoleFlag(value) {
  return value === true || value === 'true' || value === '1' || value === 1;
}

function inferSalesTerritoryType(role = {}) {
  const explicitType = String(role.territory_type || role.login_territory_type || '').trim();
  if (explicitType) return explicitType;
  const territoryId = String(role.territory_id || '').trim().toUpperCase();
  return SALES_MANAGER_TERRITORY_TYPES.includes(territoryId) ? territoryId : '';
}

function resolveSelectedRoleContext(user = {}, roleItem = {}) {
  const roleId = String(roleItem.role_id || user.role_id || '');
  const roleName = roleItem.role_name || user.role_name || '';
  const isSales = normalizeRoleFlag(roleItem.is_sales) || roleName === '销售' || roleId === '2';
  const territoryId = roleItem.territory_id || user.territory_id || '';
  const territoryType = roleItem.territory_type || (isSales ? inferSalesTerritoryType(roleItem) : '') || user.territory_type || '';

  return normalizeSalesOverviewContext({
    user_id: user.user_id || getLocalStorage('user_id') || '',
    user_name: user.user_name || getLocalStorage('user_name') || '',
    role_id: roleId,
    role_name: roleName,
    territory_id: territoryId,
    territory_type: territoryType,
    is_sales: isSales ? '1' : '0',
    enable_ai: user.enable_ai,
  });
}

export default {
  data() {
    return {
      isDirectLogin: false,
      isloging: false,
      savedLanguage: 'ZH',
      clearable: true,
      type: 'text',
      value: '',
      showEye: true,
      loginObj: {
        userId: '',
        userName: '',
        userNameTips: '',
        userIdTips: ''
      },
      eyeObj: {
        open: false,
        reverse: false
      },
      loading: false,
      login_client_type: '',
      showRoleSelectPopup: false,
      rolePopupList: []
    };
  },
  computed: {
  },
  created() {
    const USERID = getLocalStorage('user_id');
    const savedLanguage = getLocalStorage('language');
    if (USERID) {
      this.loginObj.userId = USERID;
    }
    this.savedLanguage = /^en/i.test(savedLanguage || '') ? 'EN' : 'ZH';
    removeAllLocalStorage();
    setLocalStorage('language', this.savedLanguage);
  },
  mounted() {
    this.$i18n.locale = this.savedLanguage;
    setLocalStorage('language', this.$i18n.locale);
    if (this.$route.query.user_id) {
      this.loginObj.userId = this.$route.query.user_id;
      this.isDirectLogin = true;
      this.loginFn('userid');
    }
  },
  methods: {
    settingLan(LAN) {
      this.$i18n.locale = LAN;
      setLocalStorage('language', this.$i18n.locale);
    },
    blurUserName() {
      if (this.loginObj.userName) {
        this.loginObj.userNameTips = '';
      }
    },
    blurPwd() {
      if (this.loginObj.userId) {
        this.loginObj.userIdTips = '';
      }
    },
    addLoginLog(userRole) {
      let sessionId = 's' + (new Date().getTime());
      let data = {
        user_id: userRole.user_id,
        login_time: new Date(),
        session: sessionId,
        login_type: 'mobile',
        login_client_type: this.login_client_type,
        territory_id: userRole.territory_id
      };
      if (!data.territory_id) {
        delete data.territory_id;
      }
      setLocalStorage('sessionId', sessionId);
      loginLog(data).then(res => {
      });
    },
    ajaxLogin() {
      let data = {
        user_name: this.loginObj.userName,
        user_id: this.loginObj.userId
      };
      setLocalStorage('user_id', this.loginObj.userId);
      setLocalStorage('user_name', this.loginObj.userName);
      let loginTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss a');
      setLocalStorage('login_time', loginTime);
      this.isloging = true;
      auth(data.user_id).then(token => {
        setToken({
          'seed': token.seed,
          'app_id': token.token,
          'device_id': crypto.TripleDES.encrypt(token.login_id, crypto.enc.Utf8.parse(token.seed.substr(0, 24)), { mode: crypto.mode.ECB }).toString()
        });
        this.$store.dispatch('setSeed', token.seed);
        this.authLogin(data);
      }).catch(e => {
        this.authLogin(data);
      });
    },
    getSortDy(user_id) {
      py.getSortDynamicsByUserId(user_id).then(res => {
        if (res && res.value.length) {
          setLocalStorage('sort_dynamic_id', res.value[0].sort_dynamic_id);
          setLocalStorage('SortDynamics', JSON.stringify(res.value[0]));
        }
      }).catch(e => {
      });
    },
    authLogin(data) {
      // login(data).then(res => {
      getTerrId(data).then(res => {
        this.addLoginLog();
        if (res.value && res.value.length > 0) {
          clearManagerOverviewPeriodState();
          const normalizedLegacyContext = normalizeSalesOverviewContext({
            role_id: res.value[0].role_id,
            role_name: res.value[0].role_name,
            territory_id: res.value[0].territory_id,
            territory_type: res.value[0].territory_type,
          });
          res.value[0].territory_id = normalizedLegacyContext.territory_id;
          res.value[0].territory_type = normalizedLegacyContext.territory_type;
          // setLocalStorage('user_name', res.value[0].territory_name);
          setLocalStorage('territory_id', res.value[0].territory_id);
          setLocalStorage('territory_type', res.value[0].territory_type);
          // 编辑权限
          if (res.value[0].user) {
            this.$store.dispatch('setEDITPERSSION', res.value[0].user.user_edit_permission);
            setLocalStorage('enable_ai', resolveEnableAI(res.value[0].user.enable_ai, res.value[0].role_id, res.value[0].role_name) ? '1' : '0');
          }
          this.$store.commit('GET_TERR_TYPE');
          if (res.value[0].territory_type === 'MR') {
            const stepObj = getLocalStorage('stepObj');
            // no 不是首次 yes 首次
            if (!stepObj) {
              let stepObj = {};
              for (let i = 0; i < 9; i++) {
                stepObj['step' + i] = 0;
              }
              setLocalStorage('stepObj', JSON.stringify(stepObj));
              this.$store.dispatch('setFIRST', 'yes');
              this.$store.dispatch('setSTEP', 0);
            }
          } else {
            this.$store.dispatch('setSTEP', -1);
          }
          this.getSortDy(res.value[0].user_id);
          this.$store.dispatch('settingUserData', res.value[0]);
          this.$store.dispatch('setWaterMarket');
          this.isloging = false;
          this.loading = false;
          this.$router.push({
            path: '/hcp/home'
          });
        } else {
          this.loginObj.userIdTips = '该区域暂无数据';
          this.loginObj.userNameTips = '该区域暂无数据';
          this.isloging = false;
          this.loading = false;
        }
      }).catch(e => {
        this.loginObj.userIdTips = '';
        this.loginObj.userNameTips = '';
        this.isloging = false;
        this.loading = false;
      });
    },
    adminLogin() {
      adminLogin({
        admin: this.loginObj.admin,
        password: this.loginObj.password,
        userId: this.loginObj.userId,
      }).then(res => {
        if (res.isSuccess && res.data && res.data.user && res.data.user.user_id) {
          if (res.data.token) {
            setLocalStorage('token', res.data.token);
            setLocalStorage('seed', res.data.seed);
          }
          this.loginFn('userid', res.data.user);
        }
      });
    },
    loginFn(type, userData) {
      if (this.isloging) {
        return;
      }
      this.login_client_type = type;
      this.isloging = true;
      let data = {
        // user_name: this.loginObj.userName,
        user_id: this.loginObj.userId
      };

      // setLocalStorage('user_id', data.user_id);
      // this.$router.push({
      //   path: '/hcp/list'
      // });

      const handleLoginSuccess = (roleInfo) => {
        clearManagerOverviewPeriodState();
        const normalizedRoleContext = normalizeSalesOverviewContext({
          role_id: roleInfo.role_id,
          role_name: roleInfo.role_name,
          territory_id: roleInfo.territory?.territory_id,
          territory_type: roleInfo.territory?.territory_type,
        });
        roleInfo.territory = {
          ...(roleInfo.territory || {}),
          territory_id: normalizedRoleContext.territory_id,
          territory_type: normalizedRoleContext.territory_type,
        };
        this.addLoginLog(roleInfo);
        setLocalStorage('is_sales', roleInfo.is_sales);
        setLocalStorage('is_msl', roleInfo.is_msl);
        setLocalStorage('user_id', roleInfo.user_id);
        setLocalStorage('role_id', roleInfo.role_id);
        setLocalStorage('role_name', roleInfo.role_name);
        setLocalStorage('enable_ai', resolveEnableAI(roleInfo.enable_ai ?? roleInfo.user?.enable_ai, roleInfo.role_id, roleInfo.role_name) ? '1' : '0');
        setLocalStorage('territory_type', roleInfo.territory?.territory_type);
        setLocalStorage("territory_id", roleInfo.territory?.territory_id);
        setLocalStorage("user_name", roleInfo.user.user_name);
        if (roleInfo.login_roles) {
          setLocalStorage('login_roles', JSON.stringify(roleInfo.login_roles));
        } else if (roleInfo.user?.login_roles) {
          setLocalStorage('login_roles', JSON.stringify(roleInfo.user.login_roles));
        }

        this.$store.dispatch('setWaterMarket');

        // For MSL, check TA
        getUserTa(data).then(resTa => {
          if (resTa.value && resTa.value.length > 0) {
            setLocalStorage('ta', resTa.value[0].ta);
            setLocalStorage('ta_id', resTa.value[0].ta_id);
            setLocalStorage('user_id', resTa.value[0].user_id);
            setLocalStorage('tas', resTa.value.map(item => item.ta_id).join(','));
            // resTa.value.forEach((item) => {
            //   if (item.ta_id === 'Neurology_000001') {
            //     setLocalStorage('is_neu', 1);
            //   } else if (item.ta_id === 'Psychiatry_000001') {
            //     setLocalStorage('is_psy', 1);
            //   }
            // });
          }
          this.getUserIdKey(roleInfo.user_id);
          this.isloging = false;
        });
      };

      if (userData) {
        let currentRole = {};
        if (userData.login_roles && userData.login_roles.length > 0) {
          currentRole = userData.login_roles.find(r => r.role_id === userData.role_id) || {};
        }

        const roleInfo = {
          user_id: userData.user_id,
          role_id: userData.role_id,
          role_name: userData.role_name,
          enable_ai: userData.enable_ai ?? currentRole.enable_ai,
          is_sales: currentRole.is_sales ? '1' : '0',
          is_msl: (userData.role_name === 'MSL' || currentRole.role_name === 'MA' || currentRole.is_msl) ? '1' : '0',
          territory: {
            territory_id: currentRole.territory_id,
            territory_type: userData.login_territory_type || (normalizeRoleFlag(currentRole.is_sales) ? inferSalesTerritoryType(currentRole) : '')
          },
          user: {
            user_name: userData.user_name
          },
          login_roles: userData.login_roles
        };
        handleLoginSuccess(roleInfo);
      } else {
        getUserRole(data).then(res => {
          if (res.value && res.value.length > 0) {
            handleLoginSuccess(res.value[0]);
          }
          this.isloging = false;
        });
      }
    },
    getUserIdKey(userId) {
      help.encryption(userId).then(res => {
        if (res) {
          setLocalStorage('user_id_key', res);

          let roles = [];
          try {
            const loginRolesStr = getLocalStorage('login_roles');
            if (loginRolesStr) roles = JSON.parse(loginRolesStr);
          } catch (e) {
            console.error('Parse login_roles failed', e);
          }

          const selectableRoles = ['管理员', '销售', '市场部', 'RPM', 'GBA', 'GA', 'GA管理员', 'MSL', 'MA', '医学经理', '医学部管理员'];
          const availableRoles = roles.filter(r => selectableRoles.includes(r.role_name));

          if (availableRoles.length > 1) {
            this.rolePopupList = availableRoles;
            this.showRoleSelectPopup = true;
            return;
          }

          const isMsl = getLocalStorage('is_msl') === '1';
          const roleName = getLocalStorage('role_name');
          this.finalRoute(roleName, isMsl);
        }
      });
    },
    onSelectRole(roleItem) {
      this.showRoleSelectPopup = false;
      this.handleRoleSwitch(roleItem);
    },
    handleRoleSwitch(roleItem) {
      if (!roleItem || !roleItem.role_id) return;
      this.isloging = true;
      switchRole(roleItem.role_id).then(res => {
        this.isloging = false;
        if (res.isSuccess && res.data) {
          const { token, seed, user } = res.data;
          setToken({ token, seed });
          if (user || roleItem) {
            clearManagerOverviewPeriodState();
            const selectedRole = resolveSelectedRoleContext(user || {}, roleItem);
            setLocalStorage('is_sales', selectedRole.is_sales);
            setLocalStorage('user_id', selectedRole.user_id);
            setLocalStorage('user_name', selectedRole.user_name);
            setLocalStorage('territory_id', selectedRole.territory_id);
            setLocalStorage('territory_type', selectedRole.territory_type);
            setLocalStorage('role_id', selectedRole.role_id);
            setLocalStorage('role_name', selectedRole.role_name);
            setLocalStorage('enable_ai', resolveEnableAI(selectedRole.enable_ai, selectedRole.role_id, selectedRole.role_name) ? '1' : '0');

            const medicalRoles = ['MSL', 'MA', '医学经理', '医学部管理员'];
            const isMsl = medicalRoles.includes(selectedRole.role_name) ? '1' : '0';
            setLocalStorage('is_msl', isMsl);

            this.finalRoute(selectedRole.role_name, isMsl === '1');
          }
        } else {
          const isMsl = getLocalStorage('is_msl') === '1';
          const roleName = getLocalStorage('role_name');
          this.finalRoute(roleName, isMsl);
        }
      }).catch(e => {
        this.isloging = false;
        const isMsl = getLocalStorage('is_msl') === '1';
        const roleName = getLocalStorage('role_name');
        this.finalRoute(roleName, isMsl);
      });
    },
    finalRoute(roleName, isMsl) {
      if (roleName === 'GA管理员') {
        this.$router.push({
          path: "/ga-admin/overview",
        });
      } else if (roleName === 'GBA' || roleName === 'GA') {
        this.$router.push({
          path: "/gba/overview",
        });
      } else if (isMsl) {
        console.log('isMsl', isMsl);
        document.title = 'KOL 360';
        this.$router.push({
          path: "/kol/home",
        });
      } else {
        this.$router.push({
          path: isSalesManagerTerritory() || isEnableAI() ? "/hcp/overview" : "/hcp/list",
        });
      }
    },
  }
};
